import axios from "axios";

const loadUsers = (callback) => {
    const config = {
        url: '/api/users',
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteUser = (id, callback) => {
    const config = {
        url: `/api/users/${id}`,
        method: 'DELETE',
    }

    axios.request(config).then(response => callback(response.data));
}

const getUser = (userId, callback) => {
    const config = {
        url: `/api/users/${userId}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const updateUser = (userId, userData, callback) => {
    const config = {
        url: `/api/users/${userId}`,
        method: 'PUT',
        data: userData,
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const create = (userData, callback) => {
    const config = {
        url: "/api/users",
        method: 'POST',
        data: userData
    }

    axios.request(config)
        .then(response => callback(response.data))
}

const UserActions = {
    loadUsers,
    getUser,
    create,
    updateUser,
    deleteUser
}

export default UserActions